export default __webpack_public_path__ + "static/0219-df4b069ce528940a2223392e997b77db.png";